import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getOrders from './getOrders.graphql';
import EaterDetails from '../../../components/Shop/EaterDetails/EaterDetails';
import Loader from '../../../components/Common/Loader';

class EaterReceiptDetailsContainer extends React.Component {
    static defaultProps = {
        orderData: {
            loading: true,
            getOrders: null
        }
    }

    render() {
        const { type, bookingId, orderData, orderData: { loading, getOrders } } = this.props;
        return (
            <div>
                <div>
                    {
                        !loading && orderData && <EaterDetails
                            type={type}
                            bookingId={bookingId}
                            data={getOrders && getOrders.result}
                        />
                    }
                    {
                        (loading || (loading && !orderData)) && <Loader type="text" />
                    }
                </div>
            </div>
        );
    }
}

export default compose(
    graphql(getOrders, {
        name: 'orderData',
        options: (props) => ({
            variables: {
                id: props.bookingId
            },
            fetchPolicy: 'network-only',
            ssr: true
        })
    })
)(EaterReceiptDetailsContainer);